module.exports = __webpack_public_path__ + "static/media/Manufacturing.8dda3771.png";